<template>
    <button type="button"
        class="flex h-full items-center justify-center px-1 text-xl outline-none
            hover:bg-gray-50 focus:bg-gray-50 active:bg-gray-100">
        <slot />
    </button>
</template>
